module.exports = __webpack_public_path__ + "static/hexa_exce-9102adbe739ce984d96acb9c1801cb01.svg";